const EditTenant_mutate = `
    mutation editTenant(
      $name: String!
      $tenantId: Int!
      $contactEmail: String!
      ) {
      editTenant(
        name: $name,
        contactEmail: $contactEmail,
        tenantId: $tenantId) {
        tenant
          {
            tenantId
            name
            contactEmail
            createBy
            createDate
            updateBy
            updateDate
          }
      }
    }
`;

const GetTenantDataByUser_query = `
    query
    {
      getUserTenantData
      {
          tenantId
          countries
          states
          name
          contactEmail
          createBy
          createDate
          updateBy
          updateDate
          statesList{
            id 
            name 
            code
          }
          countriesList{
            id 
            name 
            code
          }
      }
    }
`;

const UpdateTenantStateCountry_query = `
    query
    {
      updateTenantStateCountry{
          name
          states
          countries
        }
    }
`;

const UpdateTenantCountries = `mutation updateTenantCountries($tenantId:Int!, $updateValue: String!){
  updateTenantCountries(
    tenantId: $tenantId,
    updateValue: $updateValue
  ){
    response
  }
}`;

const UpdateTenantStates = `mutation updateTenantStates($tenantId:Int!, $updateValue: String!){
  updateTenantStates(
    tenantId: $tenantId,
    updateValue: $updateValue
  ){
    response
  }
}`;

const TenantAllUser_query = `query tenantAllUser($tenantId:Int!){
  tenantAllUser(tenantId: $tenantId){
    tenantUserId
    tenantId
    {
      name
      contactEmail
    }
    isTenantAdmin
    userId{
      id
      firstName
      lastName
      username
      dateJoined
      isActive
      email
      phoneNo
      city
      state
      country
      profile{
        activationDate
      }
      deletable
    }
  }
}`;

const UpdateTenantUserIsActive = `mutation updateTenantUserIsactive($userId:Int!, $isActive: Boolean!){
  updateTenantUserIsactive(
    userId: $userId,
    isActive: $isActive
  ){
    response
  }
}`;

const DeleteTenantUser = `mutation deleteTenantUser($userId:Int!){
  deleteTenantUser(
    userId: $userId,
  ){
    response
  }
}`;

module.exports = {
  EDIT_TENANT_MUTATION: EditTenant_mutate,
  GET_TENANT_DATA_BY_USER: GetTenantDataByUser_query,
  UPDATE_TENANT_STATE_COUNTRY: UpdateTenantStateCountry_query,
  UPDATE_TENANT_COUNTRIES: UpdateTenantCountries,
  UPDATE_TENANT_STATES: UpdateTenantStates,
  TENANT_ALL_USERS_QUERY: TenantAllUser_query,
  UPDATE_TENANT_USER_ISACTIVE: UpdateTenantUserIsActive,
  DELETE_TENANT_USER_MUTATION: DeleteTenantUser,
};
